import { render, staticRenderFns } from "./BudgetListComponent.vue?vue&type=template&id=0745cf32&"
import script from "./BudgetListComponent.vue?vue&type=script&lang=js&"
export * from "./BudgetListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports